/* eslint-disable no-console */
import {isProdEnvironment} from '/util/env.util';

export const log = (...args: any[]) => {
  if (!isProdEnvironment()) {
    console.log(...args);
    // @ts-expect-error TS(2339): Property 'tron' does not exist on type 'Console'.
    console.tron?.(...args);
  }
};

export const error = (...args: any[]) => {
  if (!isProdEnvironment()) {
    console.error(...args);
    // @ts-expect-error TS(2339): Property 'tron' does not exist on type 'Console'.
    console.tron?.(...args);
  }
};
